var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalIconTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.606,
    height: 15.902,
    viewBox: "0 0 13.606 15.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11765",
    "data-name": "Group 11765",
    transform: "translate(-4.29 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11765-2",
    "data-name": "Group 11765",
    transform: "translate(4.29 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49531",
    "data-name": "Path 49531",
    d: "M28.175,5.409H24.86V2a1.113,1.113,0,0,1,.7.373c.6.676,1.859,2.082,2.42,2.713a1.034,1.034,0,0,1,.2.323Z",
    transform: "translate(-14.638 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49532",
    "data-name": "Path 49532",
    d: "M13.941,6.542a.562.562,0,0,1-.567-.567V2H5.423A1.128,1.128,0,0,0,4.29,3.138V16.764A1.128,1.128,0,0,0,5.423,17.9h11.36a1.133,1.133,0,0,0,.78-.333,1.158,1.158,0,0,0,.333-.805V6.542ZM7.128,5.409H9.965a.567.567,0,1,1,0,1.133H7.128a.567.567,0,0,1,0-1.133Zm5.68,10.222H11.1a.571.571,0,0,1,0-1.138h1.7a.571.571,0,0,1,0,1.138Zm2.271,0a.571.571,0,1,1,.567-.567.571.571,0,0,1-.567.567Zm0-3.409H7.128a.567.567,0,0,1,0-1.133h7.951a.567.567,0,0,1,0,1.133Zm0-2.838H7.128a.571.571,0,0,1,0-1.138h7.951a.571.571,0,0,1,0,1.138Z",
    transform: "translate(-4.29 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalIconTwo);
export default __webpack_public_path__ + "static/media/legal-icon-two.d12fcb9a9e2fcea390f6acffb1c13c02.svg";
export { ForwardRef as ReactComponent };